import { createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, vModelText as _vModelText, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "col-xxl-12" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xxl-4" }
const _hoisted_4 = { class: "card-body py-3" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column mb-5" }, [
  /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Search Filter")
], -1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = { class: "form-group col-md-12" }
const _hoisted_10 = { class: "mb-2" }
const _hoisted_11 = /*#__PURE__*/_createVNode("option", { value: "fullname" }, "Fullname", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("option", { value: "username" }, "Username", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("option", { value: "usid" }, "User ID", -1)
const _hoisted_14 = { class: "mb-2" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_17 = { class: "col-md-2" }
const _hoisted_18 = /*#__PURE__*/_createVNode("strong", null, "Search", -1)
const _hoisted_19 = { class: "col-xxl-8" }
const _hoisted_20 = { class: "card-body py-3" }
const _hoisted_21 = /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column mb-5" }, [
  /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Search Result")
], -1)
const _hoisted_22 = { class: "table-responsive" }
const _hoisted_23 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_24 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-50px rounded-start" }, "#"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-50px" }, "First Name"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-50px" }, "Middle Name"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-100px" }, "Last Name"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-90px" }, "Username"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-125px" }, "Action")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: [_ctx.widgetClasses, "card"]
        }, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, [
                    _withDirectives(_createVNode("select", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchField = $event)),
                      class: "mb-md form-control"
                    }, [
                      _hoisted_11,
                      _hoisted_12,
                      _hoisted_13
                    ], 512), [
                      [_vModelSelect, _ctx.searchField]
                    ])
                  ]),
                  _createVNode("div", _hoisted_14, [
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      name: "searchKey",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchKey = $event)),
                      placeholder: "Search here.."
                    }, null, 512), [
                      [_vShow, _ctx.searchField != 'fullname'],
                      [_vModelText, _ctx.searchKey]
                    ]),
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control fullname-class",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.fullnameFirst = $event)),
                      placeholder: "First Name"
                    }, null, 512), [
                      [_vShow, _ctx.searchField == 'fullname'],
                      [_vModelText, _ctx.fullnameFirst]
                    ]),
                    _hoisted_15,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control fullname-class",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.fullnameMiddle = $event)),
                      placeholder: "Middle Name"
                    }, null, 512), [
                      [_vShow, _ctx.searchField == 'fullname'],
                      [_vModelText, _ctx.fullnameMiddle]
                    ]),
                    _hoisted_16,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control fullname-class",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.fullnameLast = $event)),
                      placeholder: "Last Name"
                    }, null, 512), [
                      [_vShow, _ctx.searchField == 'fullname'],
                      [_vModelText, _ctx.fullnameLast]
                    ])
                  ]),
                  _createVNode("div", _hoisted_17, [
                    _createVNode("button", {
                      type: "button",
                      id: "manageUserSearch",
                      class: "btn btn-success",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.searchUser();})
                    }, [
                      _hoisted_18
                    ])
                  ])
                ])
              ])
            ])
          ])
        ], 2)
      ]),
      _createVNode("div", _hoisted_19, [
        _createVNode("div", {
          class: [_ctx.widgetClasses, "card"]
        }, [
          _createVNode("div", _hoisted_20, [
            _hoisted_21,
            _createVNode("div", _hoisted_22, [
              _createVNode("table", _hoisted_23, [
                _hoisted_24,
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                    return (_openBlock(), _createBlock("tr", { key: index }, [
                      _createVNode("td", null, "    " + _toDisplayString(item.id), 1),
                      _createVNode("td", null, _toDisplayString(item.firstName), 1),
                      _createVNode("td", null, _toDisplayString(item.middleName), 1),
                      _createVNode("td", null, _toDisplayString(item.lastName), 1),
                      _createVNode("td", null, _toDisplayString(item.username), 1),
                      _createVNode("td", null, [
                        _createVNode("a", {
                          href: "javascript:void(0);",
                          class: "btn btn-info",
                          onClick: ($event: any) => {_ctx.overrideNow(item.cifId);}
                        }, " Override ", 8, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ], 2)
      ])
    ])
  ], 512)), [
    [_vShow, !_ctx.loading]
  ])
}